import { types, getEnv, SnapshotOut } from 'mobx-state-tree';
import { observable } from 'mobx';

import { ProgressStateModelForStore, ProgressStateModel, ICommonAppEnvWithSBBaseApi } from '../index';
import { protoUtils } from '../../api/apiCommon';
import { ITicketListItemResponse } from '../../api/proto/apiContract';

export const TicketListItem = types.model('betListItem', {
    id: types.number,
    secureId: types.string,
    offerType: types.number, //OfferType
    evalState: types.number, //EvalState
    ticketState: types.number, //TicketState
    stake: types.number,
    stakePoints: types.maybeNull(types.number),
    potentialWin: types.number,
    prizeEval: types.maybeNull(types.number),
    placementDate: types.Date,
    number: types.maybeNull(types.string),
    cashout: types.maybeNull(types.number)
});

export enum TicketListTimeFilterModel { None = "None", All = "All", Day = "Day", ThreeDays = "ThreeDays", Week = "Week", TwoWeeks = "TwoWeeks", Month = "Month" };
export const TicketListTimeFilterModelForStore = types.enumeration('TicketListTimeFilterModelForStore', [TicketListTimeFilterModel.None, TicketListTimeFilterModel.All, TicketListTimeFilterModel.Day, TicketListTimeFilterModel.ThreeDays, TicketListTimeFilterModel.Week, TicketListTimeFilterModel.TwoWeeks, TicketListTimeFilterModel.Month]);

export enum TicketListStateFilterModel { None = "None", Accepted = "Accepted", Win = "Win", Loss = "Loss", Cancel = "Cancel", CancelWithHandlingFee = "CancelWithHandlingFee", Cashout = "Cashout", Storno = "Storno" };
export const TicketListStateFilterModelForStore = types.enumeration('TicketListStateFilterModelForStore', [TicketListStateFilterModel.None, TicketListStateFilterModel.Accepted, TicketListStateFilterModel.Win, TicketListStateFilterModel.Loss, TicketListStateFilterModel.Cancel, TicketListStateFilterModel.CancelWithHandlingFee, TicketListStateFilterModel.Cashout, TicketListStateFilterModel.Storno]);

export const BaseTicketListStore = types
    .model('ticketList', {
        tickets: types.optional(types.array(TicketListItem), []),
        totalTicketsCount: types.optional(types.number, 0),
        error: types.maybeNull(types.string),
        state: types.optional(ProgressStateModelForStore, ProgressStateModel.NotInitialized),
        isLastActionSetFilter: types.optional(types.boolean, false)
    })
    .views(self => {

        const env = getEnv<ICommonAppEnvWithSBBaseApi>(self);
        return {
            get currency() {
                return getEnv<ICommonAppEnvWithSBBaseApi>(self).settings.currency;
            },

            get isUserLogged() {
                return env.loggedUserId > 0;
            }
        }
    })
    .actions(self => {
        const setTickets = (tickets: ITicketListItemResponse[]): void => {
            self.tickets = observable([]);
            if (tickets && tickets.length) {
                tickets.forEach(ticket => {
                    self.tickets.push(
                        TicketListItem.create(<SnapshotOut<typeof TicketListItem>>{
                            offerType: ticket.OfferType,
                            id: ticket.Id, //long
                            evalState: ticket.EvalState,
                            ticketState: ticket.State,
                            placementDate: protoUtils.protoTimeStamp2Date(ticket.PlacementDate).getTime(),
                            secureId: ticket.SecureId,
                            stake: ticket.StakeValue,
                            stakePoints: ticket.StakePoints ? ticket.StakePoints.Value : null,
                            potentialWin: ticket.PrizePotentialValue,
                            prizeEval: ticket.PrizeEvalValue,
                            number: ticket.Number
                        })
                    );
                });
            }
        }

        return {
            setTickets
        };
    });

